import React from 'react';
import { useStore } from 'react-redux';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Logout from '@mui/icons-material/Logout';

interface PaymentsCartProps {
  history: {
    push: (path: string) => void;
  };
}

export default function ProfileMenu(props: PaymentsCartProps) {
  const store = useStore();
  const roleName = store.getState().auth?.user?.role?.name ?? '';
  const userName = store.getState().auth?.user?.[roleName]?.name ?? '';
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Avatar sx={{ width: 24, height: 24, cursor: 'pointer' }} onClick={handleMenu}></Avatar>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem style={{ textTransform: 'capitalize' }}> {roleName} </MenuItem>
        <MenuItem style={{ textTransform: 'capitalize' }}> {userName} </MenuItem>
        <MenuItem>
          <div
            onClick={() => {
              store.dispatch({ type: 'LOGOUT' });
              props.history.push('/');
            }}
          >
            <Logout /> Logout
          </div>
        </MenuItem>
      </Menu>
    </div>
  );
}
